module.exports = __webpack_public_path__ + "static/ig-6280f0dc07907fca07c764477e669e91.png";